module.exports = __webpack_public_path__ + "img/quotes-background@2x.442c47a4.jpg";